import React, { useState } from "react";
import { Grid, Typography } from "@mui/material";
import { ICredentialsUrbanoErrors } from "../../interfaces/configuration";
import { IValidation } from "../../interfaces/form";
import { ICredentialsModal } from "../../interfaces/modal";
import { ERRORS_MESSAGES } from "../../utils/constants";
import { validateInputs } from "../../utils/inputValidations";
import ModalBase from "./ModalBase";
import CredentialsUrbano from "../forms/CredentialsUrbano";
import GenericForm from "../GenericForm";
import ConfirmChangesCredentials from "../configuration/ConfirmChangesCredentials";
import CredentialsDimensions from "./CredentialsDimensions";

const {
  urbanoPasswordRequired,
  urbanoClientIdRequired,
  ivaRequired,
  ivaOnlyNumbers,
} = ERRORS_MESSAGES;

const formValidations: IValidation[] = [
  {
    id: "urbano_password",
    type: "required",
    message: urbanoPasswordRequired,
  },
  {
    id: "urbano_client_id",
    type: "required",
    message: urbanoClientIdRequired,
  },
  {
    id: "iva",
    type: "only-numbers",
    message: ivaOnlyNumbers,
  },
  {
    id: "iva",
    type: "required",
    message: ivaRequired,
  },
];

const CredentialsUrbanoModal = ({
  open,
  onClose,
  carrier,
  handleChangeOfConfig,
}: ICredentialsModal) => {
  const [values, setValues] = useState((carrier.credentials || {}) as any);
  const [errors, setErrors] = useState({} as ICredentialsUrbanoErrors);

  const handleSubmit = () => {
    const inputErrors = validateInputs(values, formValidations);

    setErrors(inputErrors);
    if (Object.keys(inputErrors).length === 0) {
      handleChangeOfConfig({
        _id: carrier._id,
        name: carrier.name,
        disabled: carrier.disabled,
        credentials: values,
      });
      onClose();
    }
  };

  return (
    <ModalBase open={open} handleClose={onClose} maxWidth="md">
      <Grid container>
        <Typography className="f-s-18 m-b-20">
          Ingresa los datos de tu contrato con Urbano
        </Typography>
        <GenericForm onSubmit={handleSubmit}>
          <CredentialsUrbano
            values={values}
            setValues={setValues}
            errors={errors}
          />
          <CredentialsDimensions
            values={values}
            setValues={setValues}
            errors={errors}
          />
        </GenericForm>

        <ConfirmChangesCredentials
          onClose={onClose}
          handleSubmit={handleSubmit}
        />
      </Grid>
    </ModalBase>
  );
};

export default CredentialsUrbanoModal;
